import * as tslib_1 from "tslib";
import React from 'react';
import { withDimensions } from '../../../../components/withDimensions';
export default function galleryComponentWrapper(ExternalComponent) {
    return withDimensions(/** @class */ (function (_super) {
        tslib_1.__extends(GalleryComponentWrapper, _super);
        function GalleryComponentWrapper(props) {
            var _this = _super.call(this, props) || this;
            _this.handleFilesAdded = function (data) {
                /** Update wasnt working...
                this.props.store.update('componentData', {
                  data,
                  settings: this.props.settings,
                });*/
                var curr = _this.props.store.get('componentData');
                _this.props.store.set('componentData', tslib_1.__assign({}, curr, { data: data, settings: _this.props.settings }));
            };
            var _a = _this.props, block = _a.block, store = _a.store;
            if (store) {
                var blockKey = block.getKey();
                store.setBlockHandler('handleFilesSelected', blockKey, _this.handleFilesAdded.bind(_this));
                store.setBlockHandler('handleFilesAdded', blockKey, _this.handleFilesAdded.bind(_this));
            }
            return _this;
        }
        GalleryComponentWrapper.prototype.render = function () {
            var _a = this.props, _b = _a.componentData, data = _b.data, config = _b.config, galleryLayout = _b.styles.galleryLayout, settings = _b.settings, width = _a.width;
            return (React.createElement(ExternalComponent, { config: config, data: data, layout: galleryLayout, width: width, settings: settings }));
        };
        return GalleryComponentWrapper;
    }(React.Component)));
}
//# sourceMappingURL=gallery-component-wrapper.js.map